import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["gridContent", "loadingIndicator", "button"]

  connect() {
    // Check if we need to scroll to this element on page load (if it's active)
    if (this.isButtonActive() && this.hasButtonTarget) {
      this.scrollToActiveTab();
    }
  }

  // Called when a Turbo request starts
  startLoading(event) {
    if (this.hasGridContentTarget && this.hasLoadingIndicatorTarget) {
      // Hide the grid content
      this.gridContentTarget.classList.add('hidden');
      
      // Show the loading indicator
      this.loadingIndicatorTarget.classList.remove('hidden');
    }
  }

  // Called when a Turbo request ends
  stopLoading(event) {
    if (this.hasGridContentTarget && this.hasLoadingIndicatorTarget) {
      // Show the grid content
      this.gridContentTarget.classList.remove('hidden');
      
      // Hide the loading indicator
      this.loadingIndicatorTarget.classList.add('hidden');
    }
  }

  // Check if the button is active (has the active class)
  isButtonActive() {
    if (this.hasButtonTarget) {
      return this.buttonTarget.classList.contains('bg-black');
    }
    return false;
  }

  // Scroll to the active tab when clicked
  scrollToActiveTab() {
    document.querySelectorAll('[data-loading-target="button"]').forEach(button => {
      button.classList.remove('bg-black', 'text-white');
    });
    this.buttonTarget.classList.add('bg-black', 'text-white');

    // Find the parent scrollable container
    const scrollContainer = this.buttonTarget.closest('[data-scroll-target="scrollable"]');
    if (scrollContainer) {
      // Calculate the scroll position
      const buttonRect = this.buttonTarget.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      
      // Calculate the center position for the button within the container
      const scrollLeft = this.buttonTarget.offsetLeft - (containerRect.width / 2) + (buttonRect.width / 2);
      
      // Scroll to the position smoothly
      scrollContainer.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: 'smooth'
      });
    }
  }
}
